export default function HowItWorks() {
  const steps = [
    {
      num: '01',
      icon: 'ri-search-eye-line',
      title: 'Browse Product Entries',
      desc: 'Explore organized product listings across 14 categories in the spreadsheet, with all details clearly displayed for quick scanning.',
    },
    {
      num: '02',
      icon: 'ri-scales-3-line',
      title: 'Compare Pricing & Details',
      desc: 'Evaluate multiple sellers and product variants side by side, comparing prices, sizes, and availability at a glance.',
    },
    {
      num: '03',
      icon: 'ri-check-double-line',
      title: 'Select Preferred Option',
      desc: 'Pick the best product based on your comparison and add it to your order list with a single click.',
    },
    {
      num: '04',
      icon: 'ri-send-plane-line',
      title: 'Submit Order Through System',
      desc: 'Finalize your selections and submit the order seamlessly through the integrated shopping platform.',
    },
    {
      num: '05',
      icon: 'ri-truck-line',
      title: 'Track Order Updates',
      desc: 'Monitor your order status in real-time from processing to shipping to delivery, all from one dashboard.',
    },
  ];

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 text-center mb-3">
          How It Works
        </h2>
        <p className="text-sm md:text-base text-foreground-500 text-center mb-12 max-w-xl mx-auto">
          Five simple steps to transform your shopping experience
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {steps.map((step, i) => (
            <div key={step.num} className="relative">
              <div className="bg-background-100 rounded-2xl p-5 md:p-6 text-center h-full border border-background-200/60 hover:border-accent-200 transition-all">
                <div className="w-12 h-12 mx-auto mb-4 rounded-full bg-accent-100 flex items-center justify-center">
                  <span className="text-sm font-bold text-accent-600">{step.num}</span>
                </div>
                <div className="w-10 h-10 mx-auto mb-3 flex items-center justify-center">
                  <i className={`${step.icon} text-xl text-foreground-700`}></i>
                </div>
                <h4 className="text-sm font-semibold text-foreground-900 mb-2 whitespace-nowrap">{step.title}</h4>
                <p className="text-xs text-foreground-500 leading-relaxed">{step.desc}</p>
              </div>
              {i < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-2.5 w-5 h-5 text-accent-400">
                  <i className="ri-arrow-right-s-line text-xl"></i>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}